import React, {useEffect} from 'react';
import Quote from "@system/config/quote";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useProductInventoryPriceStore } from "src/hooks/productInventoryPrice";

const SubmitQuotePopup = (props) => {
    const { data, SetStatus } = props
    const [{ }, { get_inventory_by_id, get_pricing_by_id }, { }] = useProductInventoryPriceStore();

    const onHide = () => {
        SetStatus(false)
        window.location.href = Quote.getQuoteListingRouteURL()
    };

    useEffect(() => {
        if (!(data.isSubmitted)) {
            SetStatus(true);
            quoteSubmissionEvent();
        }
    }, [data]);


    
    function quoteSubmissionEvent() {
        let quoteDetails =JSON.parse(localStorage.getItem("openQuotes"));
        let prodDetails = quoteDetails;
        prodDetails.map((data,key)=>{
          let copyObj = {...data};
          copyObj.qas = get_inventory_by_id(copyObj.ItemNumber)?.inventoryQty || 0;
          let priceVal = getPricing(copyObj);
          copyObj.priceSource = priceVal?.priceSource;
          copyObj.unitPrice = copyObj.unitPrice || priceVal?.marketPrice;
          copyObj.subtotal = copyObj.subtotal || (priceVal?.marketPrice * priceVal?.quantity);
          prodDetails[key] = copyObj;
          
        })
        localStorage.setItem("adobeEventType", "quoteSubmissionEvent");
        if (Object.keys(prodDetails).length) {
          localStorage.removeItem("openQuotes")
          HelperAdobeEvent.trackingAdobeEvent({ prodDetails });
        }
      }
      const getPricing = (ele) => {
        let priceValues = get_pricing_by_id({ uniqueId: ele.bomDetailId ? ele.bomDetailId : ele.ItemNumber })
        return priceValues && priceValues[0];
    }
  
                

    return (
        <>
            <div className="avnet-modal model-710">
                <div className="avnet-modal-inner">
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={() => { onHide() }}>×</button>

                    <div className="modal-header border-0">
                        <h3 className="modal-title m-auto" id="exampleModalLabel">{data.isSubmitted ? <b>Request Quote</b> : <b>Quote Submitted</b>}</h3>
                    </div>
                    <div className="bs5 modal-body text-center">
                        {data.isSubmitted ?
                            <>
                                Quote submission failed please retry.<br/>
                                Reach out to online support <a href="mailto:onlinesupportUS@avnet.com" className='text-decoration-underline'>onlinesupportUS@avnet.com</a>
                            </>
                            :
                            <><p><b>You have successfully submitted your quote online.</b></p>
                                <span>Response time typically takes 1-2 business days depending on supplier feedback. You will receive an email confirmation that the quotation is received and will be notified in the activity center of the quote status.</span></>}

                    </div>
                    <div className="modal-footer d-flex justify-content-center">
                        <button className="bs5 btn btn-primary"
                            onClick={() => { onHide() }}
                        >CLOSE</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SubmitQuotePopup;